import React from "react";

import { Alert } from "@mui/material";
import { Stack } from "@mui/system";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

import { ReactComponent as Calendar } from "../../../Assets/Images/Calendar.svg";
import { ReactComponent as Calendar1 } from "../../../Assets/Images/Calendar1.svg";
import { ReactComponent as Code } from "../../../Assets/Images/Code.svg";
import { ReactComponent as Expire } from "../../../Assets/Images/Expire.svg";
import { ReactComponent as ExpireRed } from "../../../Assets/Images/ExpireRed.svg";
import { ReactComponent as DollarBagICON } from "../../../Assets/Images/Icon/DollarBagICON.svg";
import { ReactComponent as PromoCode } from "../../../Assets/Images/PromoCode.svg";
import { SideDrawer } from "../../atoms/Drawer/SideDrawer";
import {
  SubHeader2
} from "../../atoms/Typography/SubHeader/SubHeader";
import { Text1 } from "../../atoms/Typography/Text/Text";

export const ViewPromoDetails = ({ close, record, OpenDrawer }) => {
  const { t } = useTranslation();
  const {
    code = "-",
    value = "-",
    createDate = "-",
    startDate = "-",
    expirationDate = "-",
    type = "-",
    validity = "-",
  } = record || {};

  return (
    <SideDrawer
      headingText={t("glossary:finance-add-promo-code.title")}
      width={"648px"}
      openDrawer={OpenDrawer}
      close={close}
      anchorDrawer={"right"}
    >
      <div>
        <Stack marginLeft={"24px"} rowGap={"20px"}>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(2,1fr)",
              gap: "16px",
            }}
          >
            <SubHeader2 icon={<Code />} text={code} />
            <SubHeader2
              icon={<Calendar />}
              text={`${validity} ${t("glossary:finance-dashboard.days")}`}
            />
            <SubHeader2 icon={<PromoCode />} text={t(`finance-add-promo-code.${type?.toLowerCase()}`, { ns: "glossary" })} />
            <SubHeader2
              icon={<Calendar1 />}
              text={dayjs(createDate).format("DD/MM/YYYY")}
            />
            <SubHeader2
              icon={<DollarBagICON />}
              text={"Rs. " + value} />
            <SubHeader2
              icon={<Expire />}
              text={dayjs(expirationDate).format("DD/MM/YYYY")}
            />
          </div>

        </Stack>
        <Stack marginTop={"24px"} direction={"row"} gap={"26px"} justifyContent={"space-between"}>
          <Alert
            icon={<ExpireRed fill="#FF3B30" fontSize="16px" height={"16px"} width={"16px"} />}
            style={{
              backgroundColor: "var(--system-red-light-05, #FFEBEA)",
              border: "1px solid var(--SystemRed-Light-1, #FFD8D5)",
              width: "100%",
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              borderRadius: "4px"
            }}
            severity="info"
          >
            <Text1 text={t("glossary:finance-dashboard.expired-promo-code")} />
          </Alert>

        </Stack>
      </div>
    </SideDrawer>
  );
};
